var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"padding-top":"8px","padding-right":"8px","padding-left":"8px"},attrs:{"src":_vm.image,"width":_vm.width,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }